<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import addzc from '../../../common/addzc/index.vue';
import seezc from '../../../common/seezc/index.vue';
import { zcfg_fycx, zcfg_delete, zcfg_fetch ,policypage} from '../../../../api/zcfg.js';
import config from '../../../../../configHttp.js';
export default {
	name: 'zcfg',
	components: {
		addzc,
		seezc
	},
	data: function() {
		return {
			gaojiss: false,
			wikiType: '1', //页面
			tablekey: 0,
			searchdata: getdata().searchdata,
			searchlist: getdata().searchlist,
			outlist: [],
			headData: getdata().headData,
			pagination: getdata().pagination,
			search: [],
			tableData: [],
			shaidiag: false,
			searchdiag: false,
			zcdiag: false,
			seezcdiag: false,
			formlist: getdata().formlist,
			seezcformlist: getdata().seezcformlist,
			seezcformdata: null,
			xinzxg: null,
			sskuang: '',
			chushuaformdata: {
				id: '',
				policyTitle: '',
				isValid: '2',
				policyType: '1',
				fbDanw: '',
				policyNum: '',
				xianggxz: '1',
				fabTime: '',
				implementTime: '',
				originalLink: '',
				policyDesc: '',
				policyFileList: [],
				policyList: [],
				wikiType: '',
        openRule: "1",
				zhongycd:'',
				remark:'',
				tagIds:[],
			},
			//跳转数据
			formdata: getdata().formdata, //form表单数据
			// originalLink: "", //源文件链接
			// content: "", //文本框数据
			fbkyuwduixi: {
				originalLink: '',
				content: ''
			}, //源文件链接文本框数据
			zclist: [], //政策
			upformdataadd: [], //文件
			overlength:0,
			options:[],
		};
	},

	mounted() {},
	created() {
		this.policypage()
		this.fetchResultShow();
		this.keyupSubmit();
	},
	methods: {
		submitSearch(){
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.gaojichaxun();
		},
		geOoverLength(e) {
			this.overlength = e;
		},	
		policypage(){
			let params = {
				size:100000000
			}
			policypage(params).then(res=>{
				if(res.data.code==1){
					this.options = res.data.data.records
					this.searchlist.map(item=>{
						if(item.prop == 'tagId'){
							item.selectval = res.data.data.records.map(item=>{
								return {
									label:item.tagName,
									value:item.id
								}
							})
						}
					})
					this.searchlist = JSON.parse(JSON.stringify(this.searchlist))
				}else{
					this.$message.error(res.data.msg)
				}
			})
		},
		keyupSubmit() {
			document.onkeydown = e => {
				let _key = window.event.keyCode;
				//!this.clickState是防止用户重复点击回车
				if (_key === 13 && !this.clickState) {
					this.shoshuokuangss();
				}
			};
		},

		confirmfilter() {},
		closeshaidiag() {},
		getdata(e) {},
		shoshuokuangss() {
			this.pagination.pageNum = 1;
			let params = {
				searchKey: this.sskuang,
				wikiType: this.wikiType
			};
			params.current = this.pagination.pageNum;
			params.size = this.pagination.pageSize;
			params.sort = '';
			params.order = '';
			zcfg_fycx(params).then(res => {
				console.log(res.data)
				if(res.data.code==1){
					this.pagination.total = res.data.data.total;
					this.tableData = res.data.data.records;
				}else{
					console.log(res.data)
					this.$message.error(res.data.msg)
				}
				
			});
		},
		gaojichaxun() {
			let params = {...this.searchdata};
			params.wikiType = '1'
			params.current = this.pagination.pageNum;
			params.size = this.pagination.pageSize;
			params.sort = '';
			params.order = '';
			console.log(params)
			zcfg_fycx(params).then(res => {
				if(res.data.code == 1){
					this.pagination.total = res.data.data.total;
				this.tableData = res.data.data.records;
				this.gaojiss = false;
				}else{
					this.$message.error(res.data.msg)
				}
				
			});
		},
		// 查询进行发票合计结果(分页)
		fetchResultShow() {
			let params = {};
			params.current = this.pagination.pageNum;
			params.size = this.pagination.pageSize;
			params.sort = '';
			params.order = '';
			params.wikiType = this.wikiType;
			zcfg_fycx(params).then(res => {
				if(res.data.code==1){
					this.pagination.total = res.data.data.total;
					this.tableData = res.data.data.records;
				}else{
					this.$message.error(res.data.msg)
				}
			});
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.fetchResultShow();
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.fetchResultShow();
		},
		forRefresh() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.fetchResultShow();
		},
		closediag() {
			this.zcdiag = false;
		},
		bianjitankuang(e) {
			let params = {};
			params.id = e.id;
			zcfg_fetch(params).then(res => {
				if (res.data.code == 1) {
					this.formdata = res.data.data
					this.formdata.id = e.id;
					this.zclist = res.data.data.policyList;
					this.fbkyuwduixi = {
						originalLink: res.data.data.originalLink,
						content: res.data.data.policyDesc
					};
					this.upformdataadd = res.data.data.policyFileList.map(item => {
						return {
							upfilename: item.filePrefix + item.fileSuffix,
							suoming: item.fileDesc,
							policyFileList: item.id
						};
					});
					this.zcdiag = true;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		rTime(date) {
			var time = new Date(date);
			var y = time.getFullYear();
			var m = time.getMonth() + 1;
			var d = time.getDate();
			var h = time.getHours();
			var mm = time.getMinutes();
			var s = time.getSeconds();
			return y + '-' + this.add0(m) + '-' + this.add0(d);
		},
		add0(m) {
			return m < 10 ? '0' + m : m;
		},
		chakangxx(e) {
			let params = {};
			params.id = e.id;
			zcfg_fetch(params).then(res => {
				if (res.data.code == 1) {
					if (res.data.data.fabTime != null && res.data.data.fabTime != '') {
						res.data.data.fabTime = this.rTime(res.data.data.fabTime);
					}
					if (res.data.data.implementTime != null && res.data.data.implementTime != '') {
						res.data.data.implementTime = this.rTime(res.data.data.implementTime);
					}

					// 该注释部分是在标题下面插入 一行 签发字号 和 日期
					// let list = res.data.data.policyDesc.split('</p>')
					// list.splice(1,0,`<p class=\"ql-align-center\">${res.data.data.policyNum}&nbsp;&nbsp;&nbsp;&nbsp;${res.data.data.fabTime}<br>`)
					// list = list.join('</p>')
					// console.log(list)
					// res.data.data.policyDesc = list
					
					if(res.data.data.policyDesc == '<p class="ql-align-right"><br></p>'){
						console.log(111)
						res.data.data.policyDesc = ''
					}
					this.formdata = res.data.data;
					this.formdata.id = e.id;
					this.zclist = res.data.data.policyList;
					this.fbkyuwduixi = {
						originalLink: res.data.data.originalLink,
						content: res.data.data.policyDesc
					};
					this.upformdataadd = [];
					res.data.data.policyFileList.forEach(element => {
						let zhancui = {
							upfilename: element.filePrefix + element.fileSuffix,
							suoming: element.fileDesc,
							policyFileList: element.id,
							fileUrl:this.$winURl + element.fileUrl
						};
						console.log(zhancui)
						this.upformdataadd.push(zhancui);
					});
					this.seezcdiag = true;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		zhengcxingz() {
			this.formdata = JSON.parse(JSON.stringify(this.chushuaformdata));
			// this.originalLink = "";
			// this.content = "";
			this.fbkyuwduixi = {
				originalLink: '',
				content: ''
			};
			this.zclist = [];
			this.upformdataadd = [];
			this.zcdiag = true;
		},
		closeseezcdiag() {
			this.seezcdiag = false;
		},
		fordelete() {
			var chooseitem = this.$refs.tablebox.getSelectionval();
			if (this.$emptyandnull(chooseitem)) {
				this.$message.error('请选择数据');
				return false;
			}
			let params = {
				wikiInfo: chooseitem.map(v => v.id)
			};

			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					zcfg_delete(params).then(res => {
						if (res.data.code == 1) {
							this.$message.success('删除成功');
							this.pagination.pageNum = 1;
							this.pagination.paginationkey++;
							this.fetchResultShow();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				}
			});
		},
		changeUpformdataadd(e) {
			this.upformdataadd = e;
		},

		jiesbaocfh(v) {
			if (v) {
				this.zcdiag = false;
				this.fetchResultShow();
			}
		},
		cannelSearch() {
			this.gaojiss = false;
		},
		// 导出进项发票合计结果
		exportExcel() {
			let selectVal = this.$refs.tablebox.getSelectionval();
			let idList = [];
			if (selectVal.length > 0) {
				idList = selectVal.map(item => item.id);
			}
			let date = {
				idList: idList,
				wikiType: this.wikiType
			};
			let params = {
				downUrl: config.baseURL + 'wiki/policy/export',
				typeObj: {
					toForm: false,
					fileName: '政策法规' + this.$timestampToStr(new Date(), 'yyyyMMdd'),
					fileType: 'xlsx',
					failUrl:this.$winURl,
				},
				params: date
			};
			this.$downloadcommon(params);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
